import React from 'react';
import AdminCreateMaterial from '../components/Admin/AdminCreateMaterial';

const AdminCreateMaterialPage = () => {
  return <AdminCreateMaterial />;
};

export default AdminCreateMaterialPage;